import { createAction } from 'redux-starter-kit';

/**
 * An action creator that puts an email recipient in the store.
 * @param {object} emailRecipient The email recipient.
 * @example dispatch(putEmailRecipient(emailRecipient));
 */
export const putEmailRecipient = createAction('PUT_EMAIL_RECIPIENT');
export const putEmailRecipients = createAction('PUT_EMAIL_RECIPIENTS');

/**
 * A action creator that removes a recipient from the store
 * @param recipientId The id of the recipient to remove.
 * @example dispatch(removeRecipient(recipientId));
 */
export const removeEmailRecipient = createAction('REMOVE_EMAIL_RECIPIENT');

/**
 * An action creator that adds recipients into the store.
 * This will replace any existing recipients with the same id.
 * @param {object[]} recipients Multiple recipients.
 * @example dispatch(addRecipients(recipients));
 */
export const addEmailRecipients = createAction('ADD_EMAIL_RECIPIENTS');

/**
 * An action creator that removes all recipients from the store.
 * @example dispatch(invalidateRecipients());
 */
export const invalidateEmailRecipients = createAction('INVALIDATE_EMAIL_RECIPIENTS');
